import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Aetna Medicare Advantage",
  shortName: "Aetna MA",
  slug: "aetna-ma-insurance",
  seoTitle: "Aetna Medicare Advantage TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have Aetna Medicare Advantage? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Aetna MA plan in Coral Springs, FL.",
  seoKeywords:
    "Aetna MA TMS coverage, Aetna Medicare Advantage TMS therapy, Aetna MA depression treatment Florida, Aetna Medicare Advantage mental health benefits Coral Springs FL, Aetna MA SAINT TMS",
  planType: "Medicare Advantage (Part C) plan",
  planRegion: "Florida and select states nationwide",
  memberTerm: "enrollees",
  behavioralHealthTerm:
    "behavioral health benefits covered under Medicare Part B parity rules",
  planSpecificIntro:
    "Aetna Medicare Advantage is a Medicare Part C plan that provides Medicare-covered benefits through a private insurer. Under federal parity rules, Aetna MA plans must cover at least what Original Medicare covers, including Medicare Part B benefits for TMS therapy when medical necessity criteria are met. However, Aetna MA plans administer these benefits through their own network and prior-authorization rules, which means coverage for TMS, accelerated protocols, and other neuromodulation services depends on your specific plan, your network, and documented medical necessity.",
  officialResourceUrl: "https://www.aetnamedicare.com/",
  officialResourceLabel: "Aetna Medicare Advantage official website",
};

export const AetnaMaInsurance = () => <InsurancePageTemplate config={config} />;
export default AetnaMaInsurance;
